import React from "react";
import PropTypes from "prop-types";
import RenderComponents from "../RenderComponents";

const RenderChildren = ({children, valueIndex, value, path, arrLength, toRenderLength}) => {
    return (
        children.map(component => (
            <RenderComponents
                key={component.id}
                actionsContext={{
                    doc: {
                        ...value,
                        _docIndex: valueIndex,
                        _arrLength: arrLength,
                        _isLast: valueIndex === (toRenderLength - 1),
                    },
                    arrayPath: path
                }}
                element={component}
                isTableCell={false}
                containerArrayPath={path ? `${path}.${valueIndex}` : ''}
            />
        ))
    )
};
export default RenderChildren
RenderChildren.propTypes = {
    children: PropTypes.array,
    valueIndex: PropTypes.number,
    value: PropTypes.any,
    path: PropTypes.string
}